<footer class="footer">
  <!-- Background Particles/Glow Effects -->
  <div class="footer-glow cosmic-glow"></div>
  <div class="footer-particles">
    <div class="particle p-1"></div>
    <div class="particle p-2"></div>
    <div class="particle p-3"></div>
  </div>

  <div class="container">
    <div class="footer-grid">
      <!-- Company Information Column -->
      <div class="footer-col company-info">
        <img src="assets/finspire-logo-redesign.webp" alt="Finspire Logo" class="footer-logo" width="160"
          height="48" />
        <p class="company-desc">
          Finspire delivers web development and results-driven digital marketing services that help businesses build a
          strong online presence, attract the right audience, and achieve sustainable growth worldwide.
        </p>
        <div class="contact-list">
          <div class="contact-item">
            <i class="fas fa-envelope"></i>
            <a href="mailto:contact@finspire.lk">contact@finspire.lk</a>
          </div>
          <div class="contact-item">
            <i class="fas fa-phone"></i>
            <div>
              <p>+94 76 4847856</p>
              <P>+94 76 3244160</P>

            </div>
          </div>
          <!-- Branch Locations -->
          <div class="branches-grid">
            <div class="branch-card main-branch">
              <div class="branch-badge">Main Branch</div>
              <div class="branch-icon">
                <i class="fas fa-building"></i>
              </div>
              <h4 class="branch-name">Kilinochchi</h4>
              <p class="branch-address">No.111 Vivekanthanagar, East Kilinochchi</p>
            </div>
            <div class="branch-card secondary-branch">
              <div class="branch-badge">Secondary Branch</div>
              <div class="branch-icon">
                <i class="fas fa-map-marker-alt"></i>
              </div>
              <h4 class="branch-name">Jaffna</h4>
              <p class="branch-address">Neeraviyadi Pillayar Kovil, Jaffna Town</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Services Quick Links -->
      <div class="footer-col">
        <div class="footer-col-title">Services</div>
        <ul class="footer-links">
          <li><a routerLink="/services" fragment="software-development">WEB DESIGN & DEVELOPMENT</a></li>
          <li><a routerLink="/services" fragment="saas-platforms">E-COMMERCE BUSINESS SOLUTIONS</a></li>
          <li><a routerLink="/services" fragment="cloud-infrastructure">SOCIAL MEDIA MARKETING</a></li>
          <li><a routerLink="/services" fragment="api-integrations">SEARCH ENGINE OPTIMIZATION</a></li>
          <li><a routerLink="/services" fragment="automation-systems">SEARCH ENGINE MARKETING</a></li>
          <li><a routerLink="/services" fragment="ecommerce-solutions">LOGO DESIGN | BRANDING SERVICES</a></li>
        </ul>
      </div>

      <!-- Blog Quick Links -->
      <div class="footer-col">
        <div class="footer-col-title">Blogs</div>
        <ul class="footer-links">
          <li *ngFor="let category of footerCategories" class="category-item">
            <a href="#" (click)="toggleCategory(category, $event)" class="category-toggle-link"
              [class.active]="category.isOpen">
              <span>{{ category.name }}</span>
              <i class="fas fa-chevron-down toggle-icon" [class.rotated]="category.isOpen"></i>
            </a>
            <ul class="submenu-links" [class.open]="category.isOpen">
              <li *ngFor="let blog of category.blogs">
                <a [routerLink]="['/blog', blog.slug]" class="submenu-blog-link">
                  {{ blog.title }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- Quick Nav Links -->
      <div class="footer-col">
        <div class="footer-col-title">Company</div>
        <ul class="footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="/works">Our Works</a></li>
          <li><a routerLink="/about-us">About Us</a></li>
          <li><a routerLink="/careers">Careers</a></li>
          <li><a routerLink="/blog">Blog</a></li>
          <li><a routerLink="/faq">FAQ</a></li>
          <li><a routerLink="/contact-us">Contact Us</a></li>
        </ul>
      </div>

      <!-- Socials & Newsletter Column -->
      <div class="footer-col newsletter-col">
        <div class="footer-col-title">Connect</div>
        <p class="newsletter-text">Follow our journey and stay updated with the latest in technology.</p>

        <div class="social-links">
          <a href="https://www.linkedin.com/company/finspiresoftwaresolution" target="_blank" rel="noopener noreferrer"
            class="social-link linkedin" aria-label="LinkedIn">
            <i class="fab fa-linkedin-in"></i>
          </a>
          <a href="https://www.facebook.com/share/1LaM55SZjo/" target="_blank" rel="noopener noreferrer"
            class="social-link facebook" aria-label="Facebook">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.instagram.com/fins_pire?igsh=Y3p0eHR2MDAzNjlj" target="_blank" rel="noopener noreferrer"
            class="social-link instagram" aria-label="Instagram">
            <i class="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>

    <!-- Gradient Divider -->
    <div class="footer-divider-gradient"></div>

    <!-- Legal Bottom Bar -->
    <div class="footer-bottom">
      <p class="copyright">Copyright © 2026 Finspire. All rights reserved.</p>
      <div class="legal-links">
        <a routerLink="/privacy-policy">Privacy Policy</a>
        <a routerLink="/terms-of-use">Terms of Use</a>
      </div>
    </div>
  </div>
</footer>